'use client'

import { createContext, useState } from 'react'

//* Helpers
import isString from 'lodash.isstring'
import safeTemplate from '@/helpers/_safeTemplate'

//* JSONs
import Languages from '@/translations'

const LanguageContext = createContext()

const LanguageProvider = (props) => {
	const [state, setState] = useState({
		selectedLang: props.selectedLang || process.env.NEXT_APP_DEFAULT_LANGUAGE || 'en',
		languages: { ...Languages },
	})

	const selectLanguage = (lang) => {
		setState({ selectedLang: lang }, () => {
			localStorage.setItem('lang', lang)
		})
	}

	const translate = (val, vars) => {
		const translationString = isString(val) && state.languages[state.selectedLang]?.[val]
		const compiled = translationString && safeTemplate(translationString)

		return (compiled && compiled(vars)) || val || 'Please Set Translate Value'
	}

	const methods = {
		selectLanguage,
		translate,
	}

	return <LanguageContext.Provider value={{ ...state, ...methods }}>{props.children}</LanguageContext.Provider>
}

export default LanguageProvider
export const LanguageConsumer = LanguageContext.Consumer
